<a
  data-dd-action-name="search-assets-name-cell-renderer.asset-link"
  [routerLink]="routerLink"
  >{{ data.name }}</a
>
@if (data.description) {
  <div class="text-sm">
    {{ data.description }}
  </div>
}
